function notifyUser(data) {
  var permissionStatus = 'default';
  if (!('Notification' in window)) {
    console.log("This browser does not support notifications.");
  } else {
      Notification.requestPermission(function(permission) {
        handlePermission(permission);
      });
  }

  function handlePermission(permission) {
    // set the button to shown or hidden, depending on what the user answers
    if(Notification.permission === 'denied' || Notification.permission === 'default') {
    } else {
      notify(data);
    }
  }

  function setNotificaionData (data) {
    var options = {}
    if (typeof data.direction != 'undefined' && data.direction != '') {
      options.dir = data.direction;
    }
    if (typeof data.language != 'undefined' && data.language != '') {
      options.lang = data.language;
    }
    if (typeof data.badge != 'undefined' && data.badge != '') {
      options.badge = data.badge;
    }
    if (typeof data.body != 'undefined' && data.body != '') {
      options.body = moveInViewModel.translate(data.body);
    }
    if (typeof data.tag != 'undefined' && data.tag != '') {
      options.tag = data.tag;
    }
    if (typeof data.iconUrl != 'undefined' && data.iconUrl != '') {
      options.icon = data.baseUrl + data.iconUrl;
    }
    if (typeof data.imageUrl != 'undefined' && data.imageUrl != '') {
      options.image = data.imageUrl;
    }
    if (typeof data.data != 'undefined' && data.data != '') {
      options.data = data.data;
    }
    if (typeof data.vibratePattern != 'undefined') {
      options.vibrate = data.vibratePattern;
    }
    if (typeof data.notifyAgain != 'undefined') {
      options.renotify = data.notifyAgain;
    }
    if (typeof data.requireInteraction != 'undefined') {
      options.requireInteraction = data.requireInteraction;
    }
    if (typeof data.silent != 'undefined') {
      options.silent = data.silent;
    }
    if (typeof data.actions != 'undefined') {
      options.actions = data.actions;
    }
    return options
  }

  function notify(data) {
    var title = moveInViewModel.translate((data.title !== '')? data.title : 'label_new_notification');
    data.iconUrl = '/templates/KO/new-css/images/notification-logo.png';
    var options = setNotificaionData(data)

    var notification = new Notification(title, options);
    if (data.redirectUrl !== 'undefined' && data.redirectUrl !== '') {
      notification.onclick = function(event) {
        event.preventDefault();
        window.open(data.redirectUrl, '_blank');
      };
    }
  }
}